import React from 'react';
import get from 'lodash/get';
import { type match } from 'react-router-dom';
import FeatureCheck from '@components/common/FeatureCheck';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import { PAGE_TYPE } from '@utils/constants';
import { CheckerPanel } from './styled';

const NocFeatureCheck = (props: { match: match; pageType?: keyof typeof PAGE_TYPE }) => {
  const { match, pageType } = props;
  const currentShareId = get(match, 'params.id', 'noc');
  return (
    <CheckerPanel>
      <DashboardTabs pageType={pageType} id={currentShareId} />
      <FeatureCheck />
    </CheckerPanel>
  );
};

export default NocFeatureCheck;
